import { Editor } from '@tiptap/core';
import { QuoteIcon } from 'lucide-react';
import React from 'react';

import { Button } from '@/ui/Button';
import { cn } from '@/utils';

interface BlockquoteMenuItemProps {
	editor: Editor | null;
}

const BlockquoteMenuItem = (props: BlockquoteMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<Button
			onClick={() => editor.chain().focus().toggleBlockquote().run()}
			disabled={!editor.can().chain().focus().toggleBlockquote().run()}
			className={cn('w-6 h-7 text-brand-gray-2 [&>svg]:size-6 [&>svg]:reset p-0 [&>svg]:left-[0px]', {
				'text-brand-blue': editor.isActive('blockquote'),
			})}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<QuoteIcon size={12} />
		</Button>
	);
};

export { BlockquoteMenuItem };
